var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.971191,
    width: 30,
    height: 30,
    rx: 8,
    fill: "black",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1236 14.1468L21.6348 8.90283H20.5658L16.6487 13.4561L13.5201 8.90283H9.91162L14.6427 15.7882L9.91162 21.2873H10.9807L15.1173 16.4789L18.4213 21.2873H22.0298L17.1233 14.1468H17.1236ZM15.6593 15.8488L15.18 15.1632L11.3659 9.70762H13.008L16.086 14.1105L16.5653 14.7961L20.5663 20.5191H18.9243L15.6593 15.8491V15.8488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX);
export default __webpack_public_path__ + "static/media/ic_x.e88757b4.svg";
export { ForwardRef as ReactComponent };